export enum VehicleRecordTypeEnum {
  OPERATIVE_UNIT_CHANGE = "OPERATIVE_UNIT_CHANGE",
}
